import { countWords } from './wordCount';
import { documentAnswerText } from './documentReview';

// JeddAI feedback on a My Draft costs 1 credit per 750 words, rounded up, with
// a minimum of 1. Mirrors SubscriptionsService.WORDS_PER_CREDIT /
// creditsForWordCount in feedbacksBackend, which bills the true cost; change
// both together.
export const WORDS_PER_CREDIT = 750;

// Refusal code the backend returns (HTTP 400) when a draft costs more credits
// than the account has left (DocumentFeedbackAdmission.Refusal).
export const INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS';

export const creditsForWordCount = (wordCount) =>
  Math.max(1, Math.ceil((Number(wordCount) || 0) / WORDS_PER_CREDIT));

// Word count of a saved My Draft as the backend prices it
// (DocumentAnswerContent.wordCount): the visible text of every answer plus its
// selected options.
export const documentWordCount = (answers) =>
  (Array.isArray(answers) ? answers : [])
    .filter((row) => row?.answer)
    .reduce((total, { answer }) => {
      const options = (answer.selectedOptions || [])
        .filter(Boolean)
        .map((option) => documentAnswerText(option.option));
      return (
        total +
        countWords([documentAnswerText(answer.answer), ...options].join(' '))
      );
    }, 0);

const credits = (count) => `${count} credit${count === 1 ? '' : 's'}`;

/**
 * Title and explanation for a draft that costs more credits than the account
 * has left, e.g. "This draft is 1,253 words, so it needs 2 credits. You have 1
 * credit left this month." When the numbers don't show a shortfall (the server
 * refused a draft the client priced within budget) it says so without a cost.
 */
export const creditShortfallCopy = ({ wordCount, remainingCredits }) => {
  const remaining = Math.max(0, Math.floor(Number(remainingCredits) || 0));
  const balance =
    remaining === 0
      ? 'You have no credits left this month.'
      : `You have ${credits(remaining)} left this month.`;
  const rate = `1 credit covers up to ${WORDS_PER_CREDIT} words.`;
  const upgrade = 'Upgrade for unlimited drafts.';
  const words = Number(wordCount);
  const cost = creditsForWordCount(words);
  if (!Number.isFinite(words) || words <= 0 || cost <= remaining) {
    return {
      title: 'Not enough credits for this draft',
      message: `This draft needs more credits than you have. ${balance} ${rate} ${upgrade}`,
    };
  }
  const length = `${words.toLocaleString('en-AU')} words`;
  const needs = credits(cost);
  return {
    title: `This draft needs ${needs}`,
    message: `This draft is ${length}, so it needs ${needs}. ${balance} ${rate} ${upgrade}`,
  };
};
